import SeoHead from '../components/SeoHead'

export default function PrivacyPolicy() {
  return (
    <section className="bg-white py-16 px-6">
      <SeoHead
        title="Privacy Policy | East County Business Center"
        description="Privacy policy for East County Business Center — how we collect, use, and protect your information."
        path="/privacy-policy"
      />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-ecbc-navy mb-8">Privacy Policy</h1>

        <div className="space-y-8 text-gray-600 leading-relaxed">
          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">1. What Information We Collect</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Name, email, and phone number at account creation</li>
              <li>Payment information processed via Square (we do not store card data — Square handles this)</li>
              <li>Booking history and membership status stored in our secure database provider</li>
              <li>Email communications sent via our email service provider</li>
              <li>Website usage data via Google Analytics</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">2. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To process bookings and membership subscriptions</li>
              <li>To send booking confirmations, receipts, and transactional emails</li>
              <li>To manage your account and membership access</li>
              <li>To improve the website and services</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">3. How We Share Your Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Square (payment processing)</li>
              <li>Our email service provider (transactional email)</li>
              <li>Google Analytics (anonymized usage data)</li>
              <li>We do not sell personal data to third parties</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">4. Data Retention</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Account data retained while account is active and for 1 year after closure</li>
              <li>Booking records retained for 3 years for accounting purposes</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">5. Your Rights (California Residents / CCPA)</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Right to know what data is collected</li>
              <li>Right to request deletion</li>
              <li>Right to opt out of data sale (we do not sell data)</li>
              <li>
                Contact: <a href="tel:6194014000" className="text-ecbc-navy underline">(619) 401-4000</a> or{' '}
                <a href="mailto:info@eastcountybiz.com" className="text-ecbc-navy underline">info@eastcountybiz.com</a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">6. Cookies</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>We use cookies for analytics (Google Analytics) and session management</li>
              <li>Users can disable cookies in their browser settings</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">7. Contact</h2>
            <p>
              East County Business Center LLC<br />
              270 East Douglas Ave, El Cajon, CA 92020<br />
              <a href="mailto:info@eastcountybiz.com" className="text-ecbc-navy underline">info@eastcountybiz.com</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
